import { intlnumberFormat } from '@patrianna/shared-utils/numbers'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import type { BalanceChange } from '@patrianna-payments/shared-store/payments/types/openApiModels/BalanceChange'
import { Currency } from '@patrianna-payments/shared-store/redeem/types/Currencies'
import { useCallback, useMemo } from 'react'

import content from 'prismic-translates/common.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type CurrencyType = {
  [Currency.SC]: string
  [Currency.GC]: string
}

export default function TransactionTitle({ balanceChange }: { balanceChange: BalanceChange[] }) {
  const getBalanceStrValue = useCallback((data: BalanceChange): string => {
    const { currency, amount } = data || { currency: '' }

    const currencyMap: CurrencyType = {
      [Currency.SC]: `+ ${t('free')} ${Currency.SC} ${intlnumberFormat(Number(amount), 'en-US', {
        minimumFractionDigits: 2,
      })}`,
      [Currency.GC]: `${intlnumberFormat(Number(amount))} ${t('gold_coins')}`,
    }

    return currencyMap[currency as Currency.SC | Currency.GC] || ''
  }, [])

  const balancesMap: CurrencyType = useMemo(() => {
    return balanceChange?.reduce(
      (acc: CurrencyType, curr) => {
        if (curr?.currency) {
          acc[curr?.currency as Currency.SC | Currency.GC] = getBalanceStrValue(curr)
        }

        return acc
      },
      { [Currency.GC]: '', [Currency.SC]: '' },
    )
  }, [balanceChange, getBalanceStrValue])

  if (balanceChange?.length < 1) {
    return null
  }

  return (
    <div className={classes.title}>
      {balancesMap?.GC && <span>{balancesMap.GC}</span>}
      {balancesMap?.SC && <span className={classes.balanceSc}>{balancesMap.SC}</span>}
    </div>
  )
}
